import React from 'react';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

let id = 0;
function createData(name, progress) {
  id += 1;
  return { id, name, progress };
}

const data = [
  createData('Company', 67),
  createData('Company', 67),
  createData('Company', 67),
  createData('Company', 67),
  createData('Company', 67)
];

const PeersTable = () => {
  return (
    <Card>
      <CardHeader
        action={
          <IconButton
            id={'menu-button'}
            // onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
        }
        subheader={'Peers Multiples'}
      />
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Peer</TableCell>
              <TableCell>2019</TableCell>
              <TableCell>2020</TableCell>
              <TableCell>2021</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(n => (
              <TableRow key={n.id}>
                <TableCell component="th" scope="row">
                  {n.name}
                </TableCell>
                <TableCell>{n.progress}</TableCell>
                <TableCell>{n.progress}</TableCell>
                <TableCell>{n.progress}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default PeersTable;
